<template lang="pug">
  .hungary
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/hungary-min.png"
      )
      span {{ gettext('Венгрия') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Венгрия является членом Европейского союза с 2004 года. Это означает, что для работодателей из стран ЕС использование венгерских граждан в качестве работников не имеет каких-либо ограничений или трудностей. Венграм не требуется разрешение на работу и пребывание.') }}
        p {{ gettext('Эта центрально-европейская страна с ее десятью миллионами жителей славится своим сельским хозяйством, гостеприимством и достижениями по многим дисциплинам. Работодатель может быть абсолютно удовлетворен навыками венгров, так как их образовательная система дает ученикам хорошие теоретические и практические знания. Медицинские и технические университеты Венгрии привлекают множество студентов из западноевропейских стран. В этих областях венгерское образование особо известно из-за своего прекрасного качества. Многие венгры могут говорить на иностранных языках, они обычно изучают английский или немецкий языки в начальной и средней школе. Поэтому большая часть молодежи владеет английский языком на среднем уровне и выше. Для людей старшей возрастной группы так же легко подтянуть свои навыки иностранного языка. По своей природе венгры доброжелательные и достаточно открытые люди, которым легко адаптироваться и интегрироваться в иностранном сообществе. Кроме того, они действительно являются кооперативными, ответственными и точными в выполнении своих обязанностей.') }}
        p {{ gettext('Венгры в их родной стране не имеют возможности обеспечить высокой заработок для каждого гражданина, и эта причина толкает их на поиски работы в более развитых европейских странах, где они смогут получать конкурентную зарплату и ценный опыт. Средняя зарплата в Венгрии составляет около 550-650 евро, а это значит, что зарплата из сектора «ниже среднего» в развитых странах ЕС всё еще будет для венгров высокой и привлекательной. ') }}
        p {{ gettext('Около 2 млн венгров работает во многих странах ЕС: Германии, Австрии, Бельгии, Словакии, Франции, Скандинавии, также в Великобритании и других странах. Они обеспечивают функционирование предприятий, строительство новых сооружений, являются специалистами в сельском хозяйстве, предоставляют различные услуги в сфере сервиса и транспорта, а также работают в медицинских учреждениях. Венгры занимают абсолютно разные должности, от простых рабочих до высококвалифицированных специалистов, что зависит от их образования, навыков и амбиций. Для Европы и других стран венгерская рабочая сила является необычайно ценным и желательным ресурсом, которая помогает строить и развивать экономику.') }}
        p {{ gettext('Согласно опыту и отзывам, венгерские сотрудники за рубежом известны как трудолюбивые и усердные работники, которые любят делать свою работу качественно и ищут новое место для жизни и работы в течение нескольких лет.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/hungary-min.png'})
  },
  name: 'Hungary',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Hungary | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/hungary/index.vue